import { removeData, setData } from "../utiles/CookieUtile";
import axios from "axios";
import uRLs from "../utiles/BaseUtile";
import { AuthTokenData } from "./apiServices";

const createToken = async (refreshToken) => {
  removeData("accessToken");
  if (!refreshToken) {
    return false;
  }
  try {
    const response = await axios.get(`${uRLs.SALE_BASE_URL}create-token`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (response) {
      setData("accessToken", response.data.results.accessToken);
      // window.location.reload();
      return response.data.results.accessToken;
    }

    throw new Error("Invalid response from create-token API");
  } catch (error) {
    throw error;
  }
};

const verifyOtp = async (otp) => {
  try {
    const verifyToken = localStorage.getItem("VerifiedToken");

    const response = await axios.post(
      `${uRLs.SALE_BASE_URL}auth-email-otp`,
      {
        verifycode: otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${verifyToken}`,
        },
      }
    );

    if (response.status !== 201) {
      let errorMessage = "An unexpected error occurred.";
      if (response.status === 422 && response.data.message) {
        errorMessage = response.data.message;
      }
      throw new Error(errorMessage);
    }

    if (response) {
      setData("accessHearinzToken", response.data.results.accessToken);
      setData("refreshHearinzToken", response.data.results.refreshToken);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

const sendOtp = async (email) => {
  try {
    const response = await axios.post(
      `${uRLs.SALE_BASE_URL}auth-email`,
      {
        email,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status !== 201) {
      let errorMessage = "An unexpected error occurred.";
      if (response.status === 422) {
        const errorData = response.data;
        errorMessage =
          errorData.message ||
          "Validation failed. Please review the provided input data and try again.";
      }
      throw new Error(errorMessage);
    }

    if (response.data.ok && response.data.results.verifyToken) {
      localStorage.setItem("VerifiedToken", response.data.results.verifyToken);
      return { verifyToken: response.data.results.verifyToken, step: 2 };
    }

    return response.data;
  } catch (error) {
    console.error("Error sending OTP:", error.message);
    throw error;
  }
};

export const authToken = async (navigate, setLoggedIn, handleError) => {
  try {
    const response = await AuthTokenData();

    const data = response.results;
    if (data) {
      setData("Email", data.username);
      setData("userRole", data.userRole);
      setData("IAT", data.iat);
      setData("EXP", data.exp);

      if (data.username) {
        setLoggedIn(true);

        if (
          window.location.pathname === "/login" ||
          window.location.pathname === "/unauthorized"
        ) {
          navigate("/dashboard");
        }
        return data;
      } else {
        setLoggedIn(false);
        navigate("/unauthorized");
      }
    }
  } catch (error) {
    handleError(error);
  }
};

export { verifyOtp, sendOtp, createToken };
